<template>
  <div id="account-change-password" tabindex="-1">
    <h1 class="title">{{ $t('account.password-change') }}</h1>
    <div class="box">
      <b-notification type="is-success" v-if="successFullChanged" :closable="false" role="status" aria-live="polite">
        {{ $t('account.password-changed-success') }}
      </b-notification>
      <b-notification type="is-danger" v-if="errors && errors.length > 0" :closable="false" role="alert" aria-live="assertive">
        <ul>
          <li v-for="(e, i) in errors" :key="i">{{ e }}</li>
        </ul>
      </b-notification>
      <ValidationObserver v-slot="{invalid}">
        <form>
          <ValidationProvider name="altes Passwort" :rules="{required: true, min: 6}" v-slot="{errors}">
            <b-field label-for="account-old-password" :label="$t('account.old-password')" class="mb-3">
              <b-input id="account-old-password" aria-describedby="error-old-password" type="password" v-model="oldpassword" password-reveal></b-input>
              <p id="error-old-password" class="help is-danger" v-for="error in errors" :key="error" role="alert" aria-live="assertive">{{ error }}</p>
            </b-field>
          </ValidationProvider>
          <ValidationProvider name="neues Passwort" :rules="{required: true, min: 6, confirmed: 'confirmation'}" v-slot="{errors}">
            <b-field label-for="account-new-password" :label="$t('account.new-passowrd')" class="mb-3">
              <b-input id="account-new-password" aria-describedby="error-new-password" type="password" v-model="newpassword" password-reveal></b-input>
              <p id="error-new-password" class="help is-danger" v-for="error in errors" :key="error" role="alert" aria-live="assertive">{{ error }}</p>
            </b-field>
          </ValidationProvider>
          <ValidationProvider name="neues Passwort wiederholen" vid="confirmation" :rules="{required: true, min: 6}" v-slot="{errors}">
            <b-field label-for="account-new-password-confirmation" :label="`${$t('account.new-passowrd')} ${$t('general.retry')}`" class="mb-3">
              <b-input id="account-new-password-confirmation" aria-describedby="error-new-password-confirmation" type="password" v-model="passwordVerify" password-reveal></b-input>
              <p id="error-new-password-confirmation" class="help is-danger" v-for="error in errors" :key="error" role="alert" aria-live="assertive">{{ error }}</p>
            </b-field>
          </ValidationProvider>
          <div class="is-sticky-mobile--bottom u-has-background-white-o75  u-p1--mobile">
            <b-button type="is-primary" class="is-fullwidth--desktop mt-4" size="is-medium" :disabled="invalid" @click="change" expanded>{{ $t('account.password-change') }}</b-button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserChangePassword',
  data() {
    return {
      newpassword: '',
      oldpassword: '',
      passwordVerify: '',
      errors: [],
      successFullChanged: false,
    }
  },
  methods: {
    async change() {
      this.errors = []

      this.successFullChanged = false
      let res = await this.$store.dispatch('$_account/changePassword', {old: this.oldpassword, new: this.newpassword})
      if (res.passwordChanged) {
        // this.newpassword = ''
        // this.oldpassword = ''
        // this.passwordVerify = ''
        this.successFullChanged = true
      } else {
        this.errors = res.errors
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
